import React, { useState, useEffect } from 'react';

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { ScrollArea } from "@/components/ui/scroll-area";

import { Calendar as CalendarIcon, Link, Trash2 } from "lucide-react";

import { useRecoilState } from 'recoil';
import { outletAtom, orgAtom, subAtom } from 'core/config/atoms';

import Moment from 'moment';
import { motion } from "framer-motion";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import Lottie from 'lottie-react';
import * as XLSX from 'xlsx';
import axios from 'axios';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';

import animBtnLoading from 'assets/anim/anim-btnLoading.json';
import TopBar from 'core/widgets/ui/TopBar';

import fileIcon from 'assets/image/ic_xfile.png';

import { API_URL } from 'services/models/AppConstent';

import ServiceMenu from 'services/serviceMenu';
import ServiceTask from 'services/serviceTask';
import ServiceRental from 'services/serviceRental';

const allowedExtensions = ["vnd.openxmlformats-officedocument.spreadsheetml.sheet", "png", "jpeg"];

export default function PanelMenu(props) {

    const [org] = useRecoilState(orgAtom);
    const [outlet] = useRecoilState(outletAtom);
    const [sub] = useRecoilState(subAtom);

    const [thubFile, setThubFile] = useState(null);
    const [thubPreview, setThubPreview] = useState(null);

    const [records, setRecords] = useState([]);
    const [catOptions, setCatOptions] = useState([]);
    const [rentalTypeOptions, setRentalTypeOptions] = useState([]);
    const [variants, setVariants] = useState([]);
    const [addons, setAddons] = useState([]);

    const [tempDoc, setTempDoc] = useState({});
    const [filter, setFilter] = useState({});

    const [date, setDate] = useState({
        from: Moment().startOf('month').toDate(),
        to: Moment().toDate(),
    });

    const [tab, setTab] = useState('all');
    const [query, setQuery] = useState('');
    const [eid, setEid] = useState('');
    const [type, setType] = useState('');

    const [addTitle, setAddTitle] = useState('');
    const [addPrice, setAddPrice] = useState('');

    const [title, setTitle] = useState('');
    const [umrp, setURMP] = useState('');
    const [utax, setUTAX] = useState('');
    const [uType, setUType] = useState('');
    const [makeTime, setMakeTime] = useState('');

    const [pageSize, setPageSize] = useState(10);
    const [pageCurrent, setPageCurrent] = useState(0);
    const [pageTotal, setPageTotal] = useState(0);

    const [isDate, setIsDate] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [submit, setSubmit] = useState(false);

    const menuService = new ServiceMenu();
    const taskService = new ServiceTask();
    const rentalService = new ServiceRental();

    const A = {};

    const B = {
        name: '',
        category: '',
        shortCode: '',
        sectionCode: '',
        type: '',
        isFav: '',
        basePrice: '',
        taxPercentage: '',
        isRental: 'FALSE',
        rentalType: '',
    };

    const formVSchemaA = Yup.object().shape({
    });

    const formVSchemaB = Yup.object().shape({
        name: Yup.string().required('This information is required'),
        category: Yup.string().required('This information is required'),
        shortCode: Yup.string().required('This information is required'),
        sectionCode: Yup.string().required('This information is required'),
        type: Yup.string().required('This information is required'),
        isFav: Yup.string().required('This information is required'),
        basePrice: Yup.string().required('This information is required'),
        taxPercentage: Yup.string().required('This information is required'),
        isRental: Yup.string().required('This information is required'),
        rentalType: Yup.string().when('isRental', {
            is: 'TRUE',
            then: (schema) => schema.required('Rental Type is required'),
            otherwise: (schema) => schema.nullable()
        }),
    });

    const getInitial = () => {
        switch (type) {
            case "B":
                return B;
            default:
                return A;
        }
    }

    const getSchema = () => {
        switch (type) {
            case "B":
                return formVSchemaB;
            default:
                return formVSchemaA;
        }
    }

    const { values, errors, touched, handleChange, handleSubmit, handleReset, resetForm, setErrors, setValues } = useFormik({
        initialValues: getInitial(),
        validationSchema: getSchema(),
        enableReinitialize: true,
        onSubmit: values => {
            if (type === "A") {
                if (thubFile == null) {
                    toast.success("Please select at least one file to upload!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                } else {
                    setSubmit(true);
                    var formData = new FormData();
                    formData.append("path", 'import');
                    formData.append("doc", thubFile);
                    fnSubmit(formData);
                }
            } else {
                if (isEdit) {
                    if (thubFile !== null) {
                        setSubmit(true);
                        if (tempDoc.media.filename === "placeholder.jpg") {
                            var formData = new FormData();
                            formData.append("path", 'menus');
                            formData.append("doc", thubFile);
                            edSubmit(formData, false);
                        } else {
                            var formData = new FormData();
                            formData.append("path", tempDoc.media.fileurl);
                            formData.append("doc", thubFile);
                            edSubmit(formData, true);
                        }
                    } else {
                        let body = {
                            "uid": eid,
                            "data": {
                                "name": values.name,
                                "category": values.category,
                                "shortCode": values.shortCode,
                                "sectionCode": values.sectionCode,
                                "type": values.type,
                                "isFav": values.isFav === "TRUE",
                                "basePrice": values.basePrice,
                                "taxPercentage": values.taxPercentage,
                                "isRental": values.isRental === "TRUE",
                                "rentalType": values.rentalType,
                                "hasVariants": variants.length !== 0,
                                "variants": variants,
                                "addons": addons,
                            }
                        }
                        menuService.updateMenu(body).then((res) => {
                            setSubmit(false);
                            if (res.status) {
                                toast.success("New Menu Updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                                setIsEdit(false);
                                setTempDoc({});
                                setEid('');
                                loadData();
                                handleReset();
                                resetForm();
                                setThubFile(null);
                                setThubPreview(null);
                                setIsAdd(false);
                            } else {
                                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                            }
                        });
                    }
                } else {
                    if (thubFile !== null) {
                        setSubmit(true);
                        var formData = new FormData();
                        formData.append("path", 'menus');
                        formData.append("doc", thubFile);
                        fnMSubmit(formData);
                    } else {
                        let body = {
                            "oid": outlet.outletid.id,
                            "outletid": outlet.outletid.outletid,
                            "name": values.name,
                            "category": values.category,
                            "shortCode": values.shortCode,
                            "sectionCode": values.sectionCode,
                            "type": values.type,
                            "isFav": values.isFav === "TRUE",
                            "basePrice": values.basePrice,
                            "taxPercentage": values.taxPercentage,
                            "isRental": values.isRental === "TRUE",
                            "rentalType": values.rentalType,
                            "hasVariants": variants.length !== 0,
                            "variants": variants,
                            "addons": addons,
                        }
                        menuService.setMenu(body).then((res) => {
                            setSubmit(false);
                            if (res.status) {
                                toast.success("New Menu Added!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                                loadData();
                                handleReset();
                                resetForm();
                                setThubFile(null);
                                setThubPreview(null);
                                setIsAdd(false);
                            } else {
                                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                            }
                        });
                    }
                }
            }
        }
    });

    const fnSubmit = (data) => {
        (async function () {
            var url = `${API_URL}file/uploadFile`;
            var requestHeaders = {
                'Content-type': 'multipart/form-data',
                'Accept': '*/*',
            };

            const responseFile = await axios.post(url, data, {
                headers: requestHeaders,
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                },
            });
            let resFile = responseFile.data.data;

            let body = {
                "org": org,
                "outlet": outlet.outletid.outletid,
                "outletName": outlet.outletid.name,
                "media": resFile,
            }

            taskService.setTask(body, '').then((res) => {
                setSubmit(false);
                if (res.status) {
                    toast.success("Menu file import job scheduled!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    setIsOpen(false);
                    setThubFile(null);
                    handleReset();
                    resetForm();
                    loadData();
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        })();
    }

    const fnMSubmit = (data) => {
        (async function () {
            var url = `${API_URL}file/uploadFile`;
            var requestHeaders = {
                'Content-type': 'multipart/form-data',
                'Accept': '*/*',
            };

            const responseFile = await axios.post(url, data, {
                headers: requestHeaders,
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                },
            });
            let resFile = responseFile.data.data;

            let body = {
                "oid": outlet.outletid.id,
                "outletid": outlet.outletid.outletid,
                "name": values.name,
                "category": values.category,
                "shortCode": values.shortCode,
                "sectionCode": values.sectionCode,
                "type": values.type,
                "isFav": values.isFav === "TRUE",
                "basePrice": values.basePrice,
                "taxPercentage": values.taxPercentage,
                "hasVariants": variants.length !== 0,
                "variants": variants,
                "addons": addons,
                "media": resFile,
            }
            menuService.setMenu(body).then((res) => {
                setSubmit(false);
                if (res.status) {
                    toast.success("New Menu Added!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    loadData();
                    handleReset();
                    resetForm();
                    setThubFile(null);
                    setThubPreview(null);
                    setIsAdd(false);
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        })();
    }

    const edSubmit = (data, isFile) => {
        (async function () {
            var url = "";
            if (isFile) {
                url = `${API_URL}file/replaceFile`;
            } else {
                url = `${API_URL}file/uploadFile`;
            }

            var requestHeaders = {
                'Content-type': 'multipart/form-data',
                'Accept': '*/*',
            };

            const responseFile = await axios.post(url, data, {
                headers: requestHeaders,
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                },
            });
            let resFile = responseFile.data.data;

            let body = {
                "uid": eid,
                "data": {
                    "name": values.name,
                    "category": values.category,
                    "shortCode": values.shortCode,
                    "sectionCode": values.sectionCode,
                    "type": values.type,
                    "isFav": values.isFav === "TRUE",
                    "basePrice": values.basePrice,
                    "taxPercentage": values.taxPercentage,
                    "isRental": values.isRental === "TRUE",
                    "rentalType": values.rentalType,
                    "hasVariants": variants.length !== 0,
                    "variants": variants,
                    "addons": addons,
                    "media": resFile,
                }
            }
            menuService.updateMenu(body).then((res) => {
                setSubmit(false);
                if (res.status) {
                    toast.success("New Menu Updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    setIsEdit(false);
                    setTempDoc({});
                    setEid('');
                    loadData();
                    handleReset();
                    resetForm();
                    setThubFile(null);
                    setThubPreview(null);
                    setIsAdd(false);
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        })();
    }

    const handleFileChange = (e) => {
        var { value, name } = e.target;
        let isError = false;

        const inputFile = e.target.files[0];
        const fileExtension = inputFile?.type.split("/")[1];

        if (!allowedExtensions.includes(fileExtension)) {
            toast.error('Only .xlsx file format is allowed, please try again!', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            isError = true;
        }

        if (isError) {
            return;
        }

        setThubFile(inputFile);

        if (fileExtension != "vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            const reader = new FileReader();
            reader.onload = () => {
                const img = new Image();
                img.onload = () => {
                    if (img.width !== 512 || img.height !== 512) {
                        toast.error('Image must be exactly 512x512 pixels!', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    } else {
                        setThubFile(inputFile);
                        setThubPreview(reader.result);
                    }
                };
                img.onerror = () => {
                    toast.error('Invalid image file.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                };
                img.src = reader.result;
            };
            reader.readAsDataURL(inputFile);
        }
    };

    const handleChangeForm = (e) => {
        const { value, name } = e.target;
        switch (name) {
            case "name":
                setAddTitle(value);
                break;
            case "price":
                setAddPrice(value);
                break;
            case "title":
                setTitle(value);
                break;
            case "type":
                setUType(value);
                break;
            case "umrp":
                setURMP(value);
                break;
            case "tax":
                setUTAX(value);
                break;
            case "utime":
                setMakeTime(value);
                break;
        }
    }

    const addVarents = () => {
        if (title !== "" && umrp !== "" && utax !== "" && makeTime !== "") {
            let tempList = [...variants];
            tempList.push({
                "title": title,
                "type": uType,
                "price": umrp,
                "tax": utax,
                "makeTime": makeTime,
                "profile_media": {},
                "status": "active"
            });
            setVariants(tempList);
            setTitle('');
            setURMP('');
            setUTAX('');
            setUType('');
            setMakeTime('');
        } else {
            toast.error('Please fill all the information.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
        }
    }

    const removeVarents = (index) => {
        let tempList = [...variants];
        tempList.splice(index, 1);
        setVariants(tempList);
    }

    const addAddOn = () => {
        if (addTitle !== "" && addPrice !== "") {
            let tempList = [...addons];
            tempList.push({
                'name': addTitle,
                'price': addPrice,
            });
            setAddons(tempList);
            setAddTitle('');
            setAddPrice('');
        } else {
            toast.error('Please fill all the information.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
        }
    }

    const removeAddOn = (index) => {
        let tempList = [...addons];
        tempList.splice(index, 1);
        setAddons(tempList);
    }

    const changeTab = (val) => {
        setTab(val);
        setQuery('');
        setDate({
            from: Moment().startOf('year').toDate(),
            to: Moment().toDate(),
        });
        switch (val) {
            case "all":
                setFilter({});
                break;
            case "active":
                setFilter({ 'status': 'active' });
                break;
            case "stock":
                setFilter({ 'status': 'stock' });
                break;
            case "disabled":
                setFilter({ 'status': 'disabled' });
                break;
            default:
                break;
        }
    }

    const handleOnChange = (e) => {
        var { value, name } = e.target;
        switch (name) {
            case 'pageSize':
                setPageSize(value);
                break;
            case 'search':
                setQuery(value);
                break;
        }
    }

    const onDateChange = (event) => {
        setIsDate(true);
        setDate(event);
    }

    const uploadMenu = () => {
        setType("A");
        setTempDoc({});
        setEid('');
        setIsEdit(false);
        setIsAdd(false);
        setIsOpen(true);
    }

    const addMenu = () => {
        setType("B");
        setTempDoc({});
        setEid('');
        setIsEdit(false);
        setIsOpen(false);
        setIsAdd(true);
    }

    const editMenu = (doc) => {
        setType("B");
        setTempDoc(doc);
        setEid(doc._id);
        setIsEdit(true);
        setIsOpen(false);
        setIsAdd(true);
    }

    const updateStatus = (id, status) => {
        let body = {
            uid: id,
            data: {
                status: status
            }
        }
        menuService.updateMenu(body).then((res) => {
            if (res['status']) {
                loadData();
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        });
    }

    const updateFav = (id, status) => {
        let body = {
            uid: id,
            data: {
                isFav: status
            }
        }
        menuService.updateMenu(body).then((res) => {
            if (res['status']) {
                loadData();
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        });
    }

    const deleteMenu = (id) => {
        let body = {
            did: id,
        }
        menuService.deleteMenu(body).then((res) => {
            if (res['status']) {
                loadData();
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        });
    }

    const deleteAll = () => {
        menuService.deleteAll({}).then((res) => {
            if (res['status']) {
                loadData();
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        });
    }

    const getTypeColor = (type) => {
        switch (type) {
            case "VEG":
                return "text-green-600 bg-green-100";
            case "EGG VEG":
                return "text-yellow-600 bg-yellow-100";
            case "NON VEG":
                return "text-prime bg-red-50";
            default:
                return "text-prime bg-red-50";
        }
    }

    const pageChange = (pageValue) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": pageValue,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? Moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await menuService.getAllMenus(body);
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    const populdata = () => {
        setValues({
            name: tempDoc.name,
            category: tempDoc.category,
            shortCode: tempDoc.shortCode,
            sectionCode: tempDoc.sectionCode,
            type: tempDoc.type,
            isFav: tempDoc.isFav ? "TRUE" : "FALSE",
            basePrice: tempDoc.basePrice,
            taxPercentage: tempDoc.taxPercentage,
            isRental: tempDoc.isRental ? "TRUE" : "FALSE",
            rentalType: tempDoc.rentalType || '',
        });
        setVariants(tempDoc.variants);
        setAddons(tempDoc.addons);
    }

    const loadRentalTypes = () => {
        (async function () {
            let body = {
                "filter": {},
                "page": 1,
                "size": 10000
            };
            var res = await rentalService.getAllRental(body);
            if (res.status) {
                const list = res.data.data || [];
                const uniqueTypes = [...new Set(list.map(item => item.type))];
                const options = uniqueTypes.map(t => ({ value: t, label: t }));
                setRentalTypeOptions(options);
            }
        })();
    }

    const loadData = () => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 1,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? Moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await menuService.getAllMenus(body);
            if (res['status']) {
                let tempCat = [];
                res.data.data.forEach(element => {
                    if (!tempCat.some(item => item.value === element.category)) {
                        tempCat.push({ value: element.category, label: element.category });
                    }
                });
                setCatOptions(tempCat);
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })
        const a = document.createElement('a')
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    const exportData = (type) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 0,
                "size": 0,
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? Moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await menuService.getAllMenus(body);
            var records = res.data.data;
            let items = [];
            records.forEach((item) => {
                items.push({
                    outletid: item.outletid,
                    menuid: item.menuid,
                    name: item.name,
                    shortCode: item.shortCode,
                    sectionCode: item.sectionCode,
                    category: item.category,
                    type: item.type,
                    price: item.basePrice,
                    tax: item.taxPercentage,
                    Favorite: item.isFav ? "Favorite" : "Regular",
                    status: item.status,
                    createdAt: item.createdAt,
                });
            });

            if (type === "xlsx") {
                const worksheet = XLSX.utils.json_to_sheet(items);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "menu");
                XLSX.writeFile(workbook, "Menu.xlsx");
            } else {
                let headers = ['outletid, menuid, name, shortCode, sectionCode, category, type, price, tax, Favorite, status, createdAt'];
                let recordCsv = items.reduce((acc, record) => {
                    const { outletid, menuid, name, shortCode, sectionCode, category, type, price, tax, Favorite, status, createdAt } = record
                    acc.push([outletid, menuid, name, shortCode, sectionCode, category, type, price, tax, Favorite, status, createdAt].join(','))
                    return acc
                }, []);
                downloadFile({
                    data: [...headers, ...recordCsv].join('\n'),
                    fileName: 'Menu.csv',
                    fileType: 'text/csv',
                });
            }
        })();
    }

    const downloadFileFromUrl = (url, filename) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = filename || 'download';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const nextPage = () => {
        if (pageCurrent < pageTotal) {
            pageChange(pageCurrent + 1);
        }
    }

    const prevPage = () => {
        if (pageCurrent > 1) {
            pageChange(pageCurrent - 1);
        }
    }

    useEffect(() => {
        loadData();
        loadRentalTypes();
    }, []);

    useEffect(() => {
        loadData();
    }, [pageSize, query, date, filter]);

    useEffect(() => {
        if (isAdd && isEdit) {
            populdata();
        }
    }, [isAdd, isEdit, tempDoc]);

    return (
        <>
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-full xl:w-[30%] min-h-screen absolute right-0 p-[20px]'>
                        <ScrollArea>
                            <div className='px-2'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>IMPORT MENU</h1>
                                    <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => {
                                        setIsOpen(false);
                                        setThubFile(null);
                                        setThubPreview(null);
                                        resetForm();
                                    }}>
                                        <span><i className="las la-times text-xl cursor-pointer"></i></span>
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <div className='flex items-center' onClick={() => { downloadFileFromUrl("https://storage.googleapis.com/bt-main-storage/assets/Menu.xlsx", "MENU.xlsx"); }} >
                                    Donwload Templae Here <span><Link size={14} className='text-blue-600 ml-1 cursor-pointer' /></span>
                                </div>
                                <form className='mt-4 w-full' onSubmit={handleSubmit} onReset={handleReset} noValidate="" autoComplete='off'>
                                    <div className="w-full">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Import File</label>
                                        {
                                            (thubFile === null) && <div className="mt-1 flex justify-center pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                                                <div className="space-y-1 text-center">
                                                    <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                        <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                    <div className="flex text-sm text-gray-600">
                                                        <label className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                            <span>Upload a file</span>
                                                            <input type="file" className="sr-only" onChange={handleFileChange} />
                                                        </label>
                                                        <p className="pl-1">or drag and drop</p>
                                                    </div>
                                                    <p className="text-xs text-gray-500">
                                                        .xlsx up to 2mb
                                                    </p>
                                                </div>
                                            </div>
                                        }
                                        {
                                            thubFile !== null && <div className="pl-3 pr-4 py-3 flex items-center justify-between text-sm bg-gray-100 rounded border mt-2">
                                                <div className="w-0 flex-1 flex items-center">
                                                    <img src={fileIcon} alt="Icon Template" className='w-10 h-10' />
                                                    <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                        {thubFile.name}&nbsp;
                                                        <i className="las la-link text-gray-400 text-lg"></i>
                                                    </span>
                                                </div>
                                                <div className="ml-4 flex-shrink-0">
                                                    <label className="relative cursor-pointer rounded-md font-medium text-indigo-600 font-mono">
                                                        <span>Replace</span>
                                                        <input type="file" className="sr-only" onChange={handleFileChange} />
                                                    </label>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    <div className='col-span-12 my-6'>
                                        <div className='flex items-end'>
                                            <button type="submit" className="text-white bg-prime hover:bg-primeLight focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center" disabled={submit}>
                                                {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                                {!submit && "IMPORT"}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </ScrollArea >
                    </div >
                </div >
            }
            {
                isAdd && <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[70%] min-h-screen absolute right-0 p-[20px]'>
                        <ScrollArea>
                            <div className='px-2'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>{isEdit ? "UPDATE" : "ADD"} OUTLET</h1>
                                    <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => {
                                        setIsAdd(false);
                                        resetForm();
                                        setThubFile(null);
                                        setThubPreview(null);
                                        loadData();
                                    }}>
                                        <span><i className="las la-times text-xl cursor-pointer"></i></span>
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <form className='mt-4 grid grid-cols-12 gap-3' onSubmit={handleSubmit} onReset={handleReset} noValidate="" autoComplete='off'>
                                    <div className="col-span-4">
                                        {
                                            isEdit && <div className="mb-6">
                                                <label className="block mb-2 text-sm font-medium text-gray-600">Logo File</label>
                                                {
                                                    (thubFile === null) && <div className="pl-3 pr-4 py-3 flex items-center justify-between text-sm bg-gray-100 rounded border mt-2">
                                                        <div className="w-0 flex-1 flex items-center">
                                                            <img src={tempDoc.media.fileurl} alt="Icon Template" className='w-10 h-10' />
                                                            <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                                {tempDoc.media.filename}&nbsp;
                                                                <i className="las la-link text-gray-400 text-lg"></i>
                                                            </span>
                                                        </div>
                                                        <div className="ml-4 flex-shrink-0">
                                                            <label className="relative cursor-pointer rounded-md font-medium text-indigo-600 font-mono">
                                                                <span>Replace</span>
                                                                <input type="file" className="sr-only" onChange={handleFileChange} />
                                                            </label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    thubFile !== null && <div className="pl-3 pr-4 py-3 flex items-center justify-between text-sm bg-gray-100 rounded border mt-2">
                                                        <div className="w-0 flex-1 flex items-center">
                                                            <img src={thubPreview} alt="Icon Template" className='w-10 h-10' />
                                                            <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                                {thubFile.name}&nbsp;
                                                                <i className="las la-link text-gray-400 text-lg"></i>
                                                            </span>
                                                        </div>
                                                        <div className="ml-4 flex-shrink-0">
                                                            <label className="relative cursor-pointer rounded-md font-medium text-indigo-600 font-mono">
                                                                <span>Replace</span>
                                                                <input type="file" className="sr-only" onChange={handleFileChange} />
                                                            </label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {
                                            !isEdit && <div className="mb-6">
                                                <label className="block mb-2 text-sm font-medium text-gray-600">Logo File</label>
                                                {
                                                    (thubFile === null) && <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                                                        <div className="space-y-1 text-center">
                                                            <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                            <div className="flex text-sm text-gray-600">
                                                                <label className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                                    <span>Upload a file</span>
                                                                    <input type="file" className="sr-only" onChange={handleFileChange} />
                                                                </label>
                                                                <p className="pl-1">or drag and drop</p>
                                                            </div>
                                                            <p className="text-xs text-gray-500">
                                                                .jpg or .png up to 2mb at 512px x 512px
                                                            </p>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    thubFile !== null && <div className="pl-3 pr-4 py-3 flex items-center justify-between text-sm bg-gray-100 rounded border mt-2">
                                                        <div className="w-0 flex-1 flex items-center">
                                                            <img src={thubPreview} alt="Icon Template" className='w-10 h-10' />
                                                            <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                                {thubFile.name}&nbsp;
                                                                <i className="las la-link text-gray-400 text-lg"></i>
                                                            </span>
                                                        </div>
                                                        <div className="ml-4 flex-shrink-0">
                                                            <label className="relative cursor-pointer rounded-md font-medium text-indigo-600 font-mono">
                                                                <span>Replace</span>
                                                                <input type="file" className="sr-only" onChange={handleFileChange} />
                                                            </label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Menu Name<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="name" value={values.name} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Vada Pav" onChange={handleChange} />
                                        {(errors.name && touched.name) && <p className='text-xs text-red-400 mt-1'>{errors.name}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Menu Category<sup className="text-red-600">*</sup></label>
                                        <CreatableSelect isClearable options={catOptions} onChange={(e) => {
                                            if (e) {
                                                setValues({ ...values, 'category': e.value });
                                            } else {
                                                setValues({ ...values, 'category': '' });
                                            }
                                        }} name="category" id="category" className="mt-1 shadow-inner" />
                                        {(errors.category && touched.category) && <p className='text-xs text-red-400 mt-1'>{errors.category}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Menu Short Code<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="shortCode" value={values.shortCode} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. VP" onChange={handleChange} />
                                        {(errors.shortCode && touched.shortCode) && <p className='text-xs text-red-400 mt-1'>{errors.shortCode}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Menu Section Code<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="sectionCode" value={values.sectionCode} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. AC" onChange={handleChange} />
                                        {(errors.sectionCode && touched.sectionCode) && <p className='text-xs text-red-400 mt-1'>{errors.sectionCode}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono">Item Type<sup className="text-red-600">*</sup></label>
                                        <select id="type" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={handleChange} value={values.type}>
                                            <option value="" disabled="" selected="selected">Select</option>
                                            <option value="VEG" selected={values.type == "VEG"}>VEG</option>
                                            <option value="EGG VEG" selected={values.type == "EGG VEG"}>EGG</option>
                                            <option value="NON VEG" selected={values.type == "NON VEG"}>NON VEG</option>
                                        </select>
                                        {(errors.type && touched.type) && <p className='text-xs text-red-400 mt-1'>{errors.type}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono">Item Is Favourite<sup className="text-red-600">*</sup></label>
                                        <select id="isFav" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={handleChange} value={values.isFav}>
                                            <option value="" disabled="" selected="selected">Select</option>
                                            <option value="TRUE" selected={values.isFav == "TRUE"}>Yes</option>
                                            <option value="FALSE" selected={values.isFav == "FALSE"}>No</option>
                                        </select>
                                        {(errors.isFav && touched.isFav) && <p className='text-xs text-red-400 mt-1'>{errors.isFav}</p>}
                                    </div>

                                    {
                                        sub && sub.apps && sub.apps.includes("APP00004") && <>
                                            <div className="col-span-4">
                                                <label className="block text-xs font-medium text-gray-700 font-mono">Is Rental Item?<sup className="text-red-600">*</sup></label>
                                                <select id="isRental" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={handleChange} value={values.isRental}>
                                                    <option value="" disabled="" selected="selected">Select</option>
                                                    <option value="TRUE" selected={values.isRental == "TRUE"}>Yes</option>
                                                    <option value="FALSE" selected={values.isRental == "FALSE"}>No</option>
                                                </select>
                                                {(errors.isRental && touched.isRental) && <p className='text-xs text-red-400 mt-1'>{errors.isRental}</p>}
                                            </div>
                                            {
                                                values.isRental === "TRUE" && <div className="col-span-4">
                                                    <label className="block mb-2 text-sm font-medium text-gray-600">Rental Type<sup className="text-red-600">*</sup></label>
                                                    <Select isClearable options={rentalTypeOptions} onChange={(e) => {
                                                        if (e) {
                                                            setValues({ ...values, 'rentalType': e.value });
                                                        } else {
                                                            setValues({ ...values, 'rentalType': '' });
                                                        }
                                                    }} value={rentalTypeOptions.find(option => option.value === values.rentalType)} name="rentalType" id="rentalType" className="mt-1 shadow-inner" />
                                                    {(errors.rentalType && touched.rentalType) && <p className='text-xs text-red-400 mt-1'>{errors.rentalType}</p>}
                                                </div>
                                            }
                                            {values.isRental !== "TRUE" && <div className="col-span-4"></div>}
                                        </>
                                    }

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Menu Base Price<sup className="text-red-600">*</sup></label>
                                        <input type="number" id="basePrice" value={values.basePrice} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xx.xx" onChange={handleChange} />
                                        {(errors.basePrice && touched.basePrice) && <p className='text-xs text-red-400 mt-1'>{errors.basePrice}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Menu Tax (%)<sup className="text-red-600">*</sup></label>
                                        <input type="number" id="taxPercentage" value={values.taxPercentage} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xx.xx" onChange={handleChange} />
                                        {(errors.taxPercentage && touched.taxPercentage) && <p className='text-xs text-red-400 mt-1'>{errors.taxPercentage}</p>}
                                    </div>

                                    <div className="col-span-12 font-medium border-b">
                                        Menu Variant information
                                    </div>

                                    <div className='col-span-12 grid grid-cols-6 gap-2'>
                                        {
                                            variants.length !== 0 && <div className="col-span-2">
                                                <ul className='w-full'>
                                                    {
                                                        variants.map((vari, index) => {
                                                            return <li className='w-full py-2 my-1 flex items-center justify-between border-b mt-1' key={index}>
                                                                <div>
                                                                    <h1 className='text-lg font-medium'>{vari.title}</h1>
                                                                    <p className='text-sm'>Price: ₹ <span className='font-medium'>{vari.price}</span> Tax: <span className='font-medium'>{vari.tax} (%)</span></p>
                                                                    <p className='text-sm'>Make Time: <b>{vari.makeTime} Min</b></p>
                                                                </div>
                                                                <div>
                                                                    <button type="button" disabled={submit} className="p-1 rounded-md text-white bg-prime hover:bg-primeLight" onClick={() => {
                                                                        removeVarents(index);
                                                                    }}><Trash2 size={18} /></button>
                                                                </div>
                                                            </li>
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        <div className="col-span-6 grid grid-cols-6 gap-3">
                                            <div className="col-span-6">
                                                <label className="block text-xs font-medium text-gray-700 font-mono">Title:<sup className="text-red-600">*</sup></label>
                                                <input type="text" name="title" onChange={handleChangeForm} autoComplete="off" className="mt-1 p-2 block w-full h-9 shadow-inner bg-white text-sm border-gray-400 rounded outline-none border" placeholder="i.e. Title" value={title} />
                                            </div>
                                            <div className="col-span-2">
                                                <label className="block text-xs font-medium text-gray-700 font-mono">MRP:<sup className="text-red-600">*</sup>&nbsp;(₹)</label>
                                                <input type="number" name="umrp" onChange={handleChangeForm} autoComplete="off" className="mt-1 p-2 block w-full h-9 shadow-inner bg-white text-sm border-gray-400 rounded outline-none border" placeholder="i.e. 100" step="any" value={umrp} />
                                            </div>
                                            <div className="col-span-2">
                                                <label className="block text-xs font-medium text-gray-700 font-mono">Type:<sup className="text-red-600">*</sup>&nbsp;(₹)</label>
                                                <select id="type" name="type" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={handleChangeForm} value={uType}>
                                                    <option value="" disabled="" selected="selected">Select</option>
                                                    <option value="VEG" selected={values.type == "VEG"}>VEG</option>
                                                    <option value="EGG VEG" selected={values.type == "EGG VEG"}>EGG</option>
                                                    <option value="NON VEG" selected={values.type == "NON VEG"}>NON VEG</option>
                                                </select>
                                            </div>
                                            <div className="col-span-2">
                                                <label className="block text-xs font-medium text-gray-700 font-mono">GST:<sup className="text-red-600">*</sup>&nbsp;(%)</label>
                                                <input type="number" name="tax" onChange={handleChangeForm} autoComplete="off" className="mt-1 p-2 block w-full h-9 shadow-inner bg-white text-sm border-gray-400 rounded outline-none border" placeholder="i.e. 5" step="any" value={utax} />
                                            </div>
                                            <div className="col-span-2">
                                                <label className="block text-xs font-medium text-gray-700 font-mono">Make Time:<sup className="text-red-600">*</sup>&nbsp;(min)</label>
                                                <input type="number" name="utime" onChange={handleChangeForm} autoComplete="off" className="mt-1 p-2 block w-full h-9 shadow-inner bg-white text-sm border-gray-400 rounded outline-none border" placeholder="i.e. 10" step="any" value={makeTime} />
                                            </div>
                                            <button type="button" disabled={submit} className="col-span-1 h-10 mt-4 p-1 text-sm font-medium rounded-md text-white bg-prime hover:bg-primeLight" onClick={() => {
                                                addVarents();
                                            }}>ADD VARIANT</button>
                                        </div>
                                    </div>

                                    <div className="col-span-12 font-medium border-b">
                                        Menu Add-Ons information
                                    </div>

                                    <div className='col-span-12 grid grid-cols-6 gap-2'>
                                        {
                                            addons.length !== 0 && <div className="col-span-2">
                                                <ul className='w-full'>
                                                    {
                                                        addons.map((addo, index) => {
                                                            return <li className='w-full flex items-center justify-between border-b mt-1' key={index}>
                                                                <div>
                                                                    <h1 className='text-sm font-medium'>{addo.name}</h1>
                                                                    <p className='text-xs'>Price: ₹ <span className='font-medium'>{addo.price}</span></p>
                                                                </div>
                                                                <div>
                                                                    <button type="button" disabled={submit} className="rounded-md text-white bg-prime hover:bg-primeLight p-1" onClick={() => {
                                                                        removeAddOn(index);
                                                                    }}><Trash2 size={18} /></button>
                                                                </div>
                                                            </li>
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        }

                                        <div className={`${addons.length === 0 ? "col-span-6" : "col-span-4"}`}></div>

                                        <div className="col-span-2">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Title:<sup className="text-red-600">*</sup></label>
                                            <input type="text" name="name" onChange={handleChangeForm} autoComplete="off" className="mt-1 p-2 block w-full h-9 shadow-inner bg-white text-sm border-gray-400 rounded outline-none border" placeholder="i.e. addon" value={addTitle} />
                                        </div>

                                        <div className="col-span-2">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Price:<sup className="text-red-600">*</sup>&nbsp;(₹)</label>
                                            <input type="number" name="price" onChange={handleChangeForm} autoComplete="off" className="mt-1 p-2 block w-full h-9 shadow-inner bg-white text-sm border-gray-400 rounded outline-none border" placeholder="i.e. 50" step="any" value={addPrice} />
                                        </div>

                                        <button type="button" disabled={submit} className="h-[38px] w-[80px] justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-prime hover:bg-primeLight mt-4" onClick={() => {
                                            addAddOn();
                                        }}>ADD</button>
                                    </div>

                                    <div className='col-span-12 my-6'>
                                        <div className='flex items-end'>
                                            <button type="submit" className="text-white bg-prime hover:bg-primeLight focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center" disabled={submit}>
                                                {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                                {!submit && "SAVE"}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </ScrollArea >
                    </div >
                </div >
            }
            <ScrollArea className='w-full h-full py-3 px-3'>
                <div className="w-full h-full">
                    <div className="grid grid-cols-12 grid-gap-2">
                        <div className="col-span-12 mt-2">
                            <div className="intro-y flex items-center justify-between h-10 border-b pb-4">
                                <h2 className="text-2xl font-medium font-serif truncate ml-2 text-ascent">
                                    <motion.i whileHover={{ scale: 1.2 }} className="las la-bars cursor-pointer" onClick={() => { props.onToggle(); }}></motion.i> Menu Master
                                </h2>
                                <div className='flex items-center space-x-2'>
                                    <DropdownMenu>
                                        <DropdownMenuTrigger>
                                            <button className="w-full py-1 px-2 h-8 rounded-md bg-prime hover:bg-primeLight text-white mr-2 font-medium"><i className="las la-file-download"></i> Action </button>
                                        </DropdownMenuTrigger>
                                        <DropdownMenuContent>
                                            <div
                                                className='bg-white shadow-md rounded-md absolute' style={{ top: '0px', left: '-64px' }}>
                                                <div>
                                                    <ul className='flex flex-col items-start p-2'>
                                                        <DropdownMenuItem>
                                                            <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                addMenu();
                                                            }}>
                                                                <div className='flex items-center text-base'>
                                                                    <p className="text-sm font-serif ml-2 font-normal">Add New</p>
                                                                </div>
                                                            </li>
                                                        </DropdownMenuItem>
                                                        <DropdownMenuItem>
                                                            <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                uploadMenu();
                                                            }}>
                                                                <div className='flex items-center text-base'>
                                                                    <p className="text-sm font-serif ml-2 font-normal">Import Menus</p>
                                                                </div>
                                                            </li>
                                                        </DropdownMenuItem>
                                                        <DropdownMenuItem>
                                                            <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                deleteAll();
                                                            }}>
                                                                <div className='flex items-center text-base'>
                                                                    <p className="text-sm font-serif ml-2 font-normal">Delete All</p>
                                                                </div>
                                                            </li>
                                                        </DropdownMenuItem>
                                                    </ul>
                                                </div>
                                            </div>
                                        </DropdownMenuContent>
                                    </DropdownMenu>
                                    <TopBar />
                                </div>
                            </div>
                            <div className="w-full mt-2 flex justify-between items-center">
                                <div className='h-10 bg-gray-100 rounded'>
                                    <ul className="intro-y flex items-center justify-center text-sm font-sans space-x-2 mx-2">
                                        <li className={`px-3 h-8 my-1 rounded flex items-center justify-center ${tab === 'all' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('all') }}>All</button></li>
                                        <li className={`px-3 h-8 my-1 rounded flex items-center justify-center ${tab === 'active' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('active') }}>Active</button></li>
                                        <li className={`px-3 h-8 my-1 rounded flex items-center justify-center ${tab === 'stock' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('stock') }}>Out of Stock</button></li>
                                        <li className={`px-3 h-8 my-1 rounded flex items-center justify-center ${tab === 'disabled' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('disabled') }}>Disabled</button></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-12 mt-4">
                        <div className="w-full shadow-md rounded-md border">
                            <table className="min-w-full divide-y divide-gray-200 px-4">
                                <thead className="bg-gray-50">
                                    <tr className=''>
                                        <th scope="col" className="border-b border-gray-200" colSpan={9}>
                                            <div className='w-full flex items-center space-x-2 px-2'>
                                                <form className="py-2 flex-grow flex items-center">
                                                    <div className='col-span-3 flex'>
                                                        <Popover>
                                                            <PopoverTrigger asChild>
                                                                <Button id="date" variant={"outline"} className={cn("w-[300px] h-8 justify-start text-left font-normal px-2", !date && "text-muted-foreground")}>
                                                                    <CalendarIcon className="mr-2 h-8 w-4" />
                                                                    {date?.from ? (
                                                                        date.to ? (
                                                                            <>
                                                                                {Moment(date.from).format('MMM DD, yyyy')} -{" "}
                                                                                {Moment(date.to).format('MMM DD, yyyy')}
                                                                            </>
                                                                        ) : (
                                                                            Moment(date.from).format('MMM DD, yyyy')
                                                                        )
                                                                    ) : (
                                                                        <span>Pick a date</span>
                                                                    )}
                                                                </Button>
                                                            </PopoverTrigger>
                                                            <PopoverContent className="w-auto p-0" align="start">
                                                                <Calendar initialFocus mode="range" defaultMonth={date?.from} selected={date} onSelect={onDateChange} numberOfMonths={2} />
                                                            </PopoverContent>
                                                        </Popover>
                                                    </div>
                                                    <div className='w-full flex col-span-9 items-center'>
                                                        <div className='w-[80px]'>
                                                            <p>Search :</p>
                                                        </div>
                                                        <input type="text" value={query} onChange={handleOnChange} name='search' placeholder="Search by name and short code." className="w-full h-8 px-2 font-sans text-sm outline-none rounded border" />
                                                    </div>
                                                </form>
                                                <div className='col-span-1 flex items-center'>
                                                    <DropdownMenu>
                                                        <DropdownMenuTrigger>
                                                            <button className="w-full py-1 px-2 h-8 rounded-md bg-prime hover:bg-primeLight text-white mr-2 font-medium"><i className="las la-file-download"></i> Export </button>
                                                        </DropdownMenuTrigger>
                                                        <DropdownMenuContent>
                                                            <div
                                                                className='bg-white shadow-md rounded-md absolute' style={{ top: '0px', left: '-64px' }}>
                                                                <div>
                                                                    <ul className='flex flex-col items-start p-2'>
                                                                        <DropdownMenuItem>
                                                                            <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                                exportData('xlsx');
                                                                            }}>
                                                                                <div className='flex items-center text-base'>
                                                                                    <p className="text-sm font-serif ml-2 font-normal">Export to .xlsx</p>
                                                                                </div>
                                                                            </li>
                                                                        </DropdownMenuItem>
                                                                        <DropdownMenuItem>
                                                                            <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                                exportData('csv');
                                                                            }}>
                                                                                <div className='flex items-center text-base'>
                                                                                    <p className="text-sm font-serif ml-2 font-normal">Export to .csv</p>
                                                                                </div>
                                                                            </li>
                                                                        </DropdownMenuItem>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </DropdownMenuContent>
                                                    </DropdownMenu>
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Name
                                        </th>
                                        <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Short Code
                                        </th>
                                        <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Item Type
                                        </th>
                                        <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Item Price
                                        </th>
                                        <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Item Variants
                                        </th>
                                        <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Favorite
                                        </th>
                                        <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            Status
                                        </th>
                                        <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                            createdAt
                                        </th>
                                        <th scope="col" className="px-2 py-3"></th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {
                                        records.length !== 0 && records.map((item, index) => {
                                            return <tr className="hover:bg-gray-100" key={index}>
                                                <td className="px-3 py-3 whitespace-nowrap cursor-pointer">
                                                    <div className="text-sm font-bold text-gray-900" onClick={() => { editMenu(item); }}>
                                                        <div className='flex items-center'>
                                                            <div className='w-[40px] h-[40px] bg-white rounded border mr-2'>
                                                                <img src={item.media.fileurl} alt='Proudct Image' className='w-full h-full' />
                                                            </div>
                                                            <div className='flex flex-col items-start'>
                                                                <div className='text-prime'>{item.name}</div>
                                                                <div className='text-sm text-gray-700'>Category - {item.category}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="px-3 py-3 whitespace-nowrap">
                                                    <div className="text-sm font-bold text-gray-900 uppercase">
                                                        {item.shortCode}
                                                    </div>
                                                </td>
                                                <td className="px-3 py-3 whitespace-nowrap">
                                                    <div className={`w-12 text-sm font-bold text-center rounded-full ${getTypeColor(item.type)}`}>
                                                        {item.type}
                                                    </div>
                                                </td>
                                                <td className="px-3 py-3 whitespace-nowrap">
                                                    <div className="w-12 text-sm font-bold text-center rounded-full">
                                                        ₹ {item.basePrice.toFixed(2)}
                                                    </div>
                                                </td>
                                                <td className="px-3 py-3 whitespace-nowrap">
                                                    <div className="text-xs font-medium text-gray-900">
                                                        Variant : ({item.variants.length})
                                                    </div>
                                                    <div className="text-xs font-medium text-gray-900">
                                                        Add-Ons : ({item.addons.length})
                                                    </div>
                                                </td>
                                                <td className="px-3 py-3 whitespace-nowrap">
                                                    <div className="w-20 text-sm font-bold text-prime bg-red-50 text-center rounded-full">
                                                        {item.isFav ? "Favorite" : "Regular"}
                                                    </div>
                                                </td>
                                                <td className="px-3 py-3 whitespace-nowrap">
                                                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase ${item.status == 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                                        {item.status.toUpperCase()}
                                                    </span>
                                                </td>
                                                <td className="px-3 py-3 whitespace-nowrap">
                                                    <div className="text-sm font-bold text-blue-600">
                                                        {Moment(item.createdAt).format('DD, MMM YYYY')}
                                                    </div>
                                                </td>
                                                <td>
                                                    <DropdownMenu>
                                                        <DropdownMenuTrigger>
                                                            <motion.i whileHover={{ scale: 1.1 }} className="las la-ellipsis-v text-lg"></motion.i>
                                                        </DropdownMenuTrigger>
                                                        <DropdownMenuContent>
                                                            <div>
                                                                <ul className='flex flex-col items-start'>
                                                                    <DropdownMenuItem>
                                                                        <li className='w-32 cursor-pointer rounded-md' onClick={() => { editMenu(item); }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-edit text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Edit Item</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                    {
                                                                        !item.isFav && <DropdownMenuItem>
                                                                            <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                                updateFav(item.id, true);
                                                                            }}>
                                                                                <div className='flex items-center text-base'>
                                                                                    <i className="las la-star text-lg"></i>
                                                                                    <p className='text-sm font-serif ml-2'>Make Favorite</p>
                                                                                </div>
                                                                            </li>
                                                                        </DropdownMenuItem>
                                                                    }
                                                                    {
                                                                        item.isFav && <DropdownMenuItem>
                                                                            <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                                updateFav(item.id, false);
                                                                            }}>
                                                                                <div className='flex items-center text-base'>
                                                                                    <i className="las la-star text-lg"></i>
                                                                                    <p className='text-sm font-serif ml-2'>Make Regular</p>
                                                                                </div>
                                                                            </li>
                                                                        </DropdownMenuItem>
                                                                    }
                                                                    {
                                                                        item.status == 'active' && <DropdownMenuItem>
                                                                            <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                                updateStatus(item.id, 'stock');
                                                                            }}>
                                                                                <div className='flex items-center text-base'>
                                                                                    <i className="las la-dolly-flatbed text-lg"></i>
                                                                                    <p className='text-sm font-serif ml-2'>Out of Stock</p>
                                                                                </div>
                                                                            </li>
                                                                        </DropdownMenuItem>
                                                                    }
                                                                    {
                                                                        item.status == 'stock' && <DropdownMenuItem>
                                                                            <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                                updateStatus(item.id, 'active');
                                                                            }}>
                                                                                <div className='flex items-center text-base'>
                                                                                    <i className="las la-dolly-flatbed text-lg"></i>
                                                                                    <p className='text-sm font-serif ml-2'>In Stock</p>
                                                                                </div>
                                                                            </li>
                                                                        </DropdownMenuItem>
                                                                    }
                                                                    {
                                                                        item.status == 'active' && <DropdownMenuItem>
                                                                            <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                                updateStatus(item.id, 'disabled');
                                                                            }}>
                                                                                <div className='flex items-center text-base'>
                                                                                    <i className="las la-ban text-lg"></i>
                                                                                    <p className='text-sm font-serif ml-2'>Disabled</p>
                                                                                </div>
                                                                            </li>
                                                                        </DropdownMenuItem>
                                                                    }
                                                                    {
                                                                        item.status == 'disabled' && <DropdownMenuItem>
                                                                            <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                                updateStatus(item.id, 'active');
                                                                            }}>
                                                                                <div className='flex items-center text-base'>
                                                                                    <i className="las la-chevron-circle-up text-lg"></i>
                                                                                    <p className='text-sm font-serif ml-2'>Active</p>
                                                                                </div>
                                                                            </li>
                                                                        </DropdownMenuItem>
                                                                    }
                                                                    {
                                                                        item.status == 'disabled' && <DropdownMenuItem>
                                                                            <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                                deleteMenu(item.id);
                                                                            }}>
                                                                                <div className='flex items-center text-base'>
                                                                                    <i className="las la-trash text-lg"></i>
                                                                                    <p className='text-sm font-serif ml-2'>Delete</p>
                                                                                </div>
                                                                            </li>
                                                                        </DropdownMenuItem>
                                                                    }
                                                                </ul>
                                                            </div>
                                                        </DropdownMenuContent>
                                                    </DropdownMenu>
                                                </td>
                                            </tr>
                                        })
                                    }
                                    {
                                        records.length === 0 && <tr className="cursor-pointer hover:bg-gray-100">
                                            <td className="px-3 py-3 whitespace-nowrap" colSpan="9">
                                                <div className="text-sm text-red-600 text-center">
                                                    No data found.
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                            <div className='flex py-2 px-4 items-center bg-blue-50'>
                                <p className='text-sm font-serif'>Show rows per page</p>
                                <select className='text-sm ml-2 bg-gray-100' name="pageSize" onChange={handleOnChange} value={pageSize}>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={40}>40</option>
                                    <option value={50}>50</option>
                                </select>
                                <div className='flex-grow'></div>
                                <p className='text-sm font-serif mr-2'>Page {pageCurrent} of {pageTotal}</p>
                                <div onClick={() => { prevPage() }}><i className={`las la-angle-left w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ${pageCurrent <= 1 ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                                <div onClick={() => { nextPage() }}><i className={`las la-angle-right w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ml-2 text-black ${pageCurrent === pageTotal ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                            </div>
                        </div>
                    </div>
                </div >
            </ScrollArea>
        </>
    )
}
